import { ArrowUpRight } from "lucide-react";

const services = [
  {
    title: "Corporate Security",
    desc: "Comprehensive on-site programs for offices, towers, and campuses — discreet, uniformed, and protocol-driven.",
    url: "https://images.unsplash.com/photo-1576731753569-3e93a228048c",
  },
  {
    title: "Retail Security",
    desc: "Loss-prevention and customer-facing protection that elevates the in-store experience without intrusion.",
    url: "https://images.unsplash.com/photo-1758633854736-8973bcd84dd1",
  },
  {
    title: "Executive Protection",
    desc: "Suited agents trained in advance work, secure transport, and quiet intervention for principals and families.",
    url: "/executive-protection.jpeg",
  },
  {
    title: "VIP Protection",
    desc: "Tailored coverage for entertainers, dignitaries, and high-profile clients — every detail anticipated.",
    url: "https://images.unsplash.com/photo-1769787301187-0fab290ba2f2",
  },
  {
    title: "Bodyguard Services",
    desc: "Single-agent and team deployments calibrated to threat level, environment, and personal preferences.",
    url: "https://images.unsplash.com/photo-1590426987415-5366b3feb642",
  },
  {
    title: "Religious Institution & Church Security",
    desc: "Discreet protection during services, weddings, funerals, and community gatherings — with reverence and resolve.",
    url: "https://images.unsplash.com/photo-1761582254905-a6479d38902c",
  },
  {
    title: "Event Security",
    desc: "Private galas, corporate functions, weddings, and large gatherings managed with composure and clarity.",
    url: "https://images.unsplash.com/photo-1764737486071-88862c3e7ea1",
  },
  {
    title: "Private Security Consulting",
    desc: "Risk assessments, residence hardening, travel advisories, and bespoke security architecture.",
    url: "https://images.unsplash.com/photo-1653227203074-ea5ac3ed9476",
  },
];

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16 reveal">
          <div className="max-w-2xl">
            <span className="overline">Service Capabilities</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
              Eight disciplines.{" "}
              <span className="text-zinc-500">One standard of execution.</span>
            </h2>
          </div>
          <p className="text-sm text-zinc-400 max-w-sm leading-relaxed">
            Each assignment is shaped around the client — environment, audience,
            risk profile, and aesthetic. Nothing is templated.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="reveal service-card group flex flex-col"
            >
              <div className="relative h-48 sm:h-44 overflow-hidden">
                <img
                  src={s.url}
                  alt={s.title}
                  className="service-img absolute inset-0 h-full w-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0c] via-black/30 to-transparent" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display text-lg text-white font-medium leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">
                  {s.desc}
                </p>
                <button
                  onClick={() => go("inquiry")}
                  data-testid={`service-card-cta-${i}`}
                  className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-zinc-300 group-hover:text-white transition-colors"
                >
                  Inquire
                  <ArrowUpRight
                    size={14}
                    strokeWidth={1.5}
                    className="text-[#1A5C40]"
                  />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
